<template>
    <el-dialog
      width="80vw"
      top="60px"
      custom-class="ap-detail"
      :visible.sync="show"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      @close="closeDialog"
      append-to-body
      :close-on-click-modal="false" 
    >
      <div slot="title" class="flex justify-content-space-between align-items-center" style="width: calc(100% - 60px)">
        <div class="flex align-items-center" style="height: 60px">
          <span class="mr-sm font-lg">{{ ap.simid }}</span>
          <span v-if="ap.expire_day" class="mr-sm" :class="ap.ap_expired ? 'text-danger' : ''">(有效期至{{ ap.expire_day | parseTime('{y}/{m}/{d}') }})</span>
          <span v-else class="text-success">{{ ap.precharge_month }}</span>
          <div v-if="ap.ap_expired" class="remind flex align-items-center">
            <span>该接入点已欠费，请尽快充值，以免影响正常使用。</span>
            <el-button type="danger" size="mini" @click="recharge">立即充值</el-button>
          </div>
        </div>
        <el-button v-if="ap.ap_expired" type="danger" icon="el-icon-delete" size="mini" @click="deleteAp">注销</el-button>
      </div>
      <el-card shadow="never" class="ap-desc" v-loading="apLoading">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form ref="apForm" class="display-form" label-position="left" :model="ap" label-width="120px">
              <el-form-item label="接入点状态">
                <div class="flex align-items-center">
                  <span v-if="ap.is_online" class="text-success font-lg">
                    <i class="iconfont icon-circle-outline"></i>
                  </span>
                  <span v-else class="text-muted font-lg">
                    <i class="iconfont icon-circle-fill"></i>
                  </span>
                  <span class="ml-xs">{{ ap.is_online ? '在线' : '离线' }}</span>
                </div>
              </el-form-item>
              <el-form-item label="绑定设备">
                <el-link :underline="false" @click="equipDetail(ap.equipid)">{{ ap.equip_name }}</el-link>
              </el-form-item>
              <template v-if="ap.first_activation">
                <el-form-item label="激活时间">
                  <span>{{ ap.first_activation | parseTime('{y}/{m}/{d} {h}:{i}:{s}') }}</span>
                </el-form-item>
                <el-form-item label="最近通讯时间">
                  <span>{{ ap.last_upload_time | parseTime('{y}/{m}/{d} {h}:{i}:{s}') }}</span>
                </el-form-item>
              </template>
              <template v-else-if="ap.first_activation == 0">
                <el-form-item label="激活时间">
                  <span>未激活</span>
                </el-form-item>
                <el-form-item label="沉默日期">
                  <div class="flex align-items-center">
                    <span>{{ ap.silent_deadline | parseTime('{y}/{m}/{d}') }}</span>
                      <span class="ml-sm text-muted tip-area " style="font-size: 28px">
                        <span class="triangle"></span>
                        <span class="tooltip">超出沉默日期，接入点将被强制激活</span>
                        <i class="iconfont icon-circle-question"></i>
                      </span>
                  </div>
                </el-form-item>
              </template>
            </el-form>
          </el-col>
          <el-col :span="8">
            <div class="bg-light radius5 flex column" style="height: 235px">
              <div class="hd front-line mt ml">通讯终端</div>
              <div class="bd flex align-items-center column pb-md">
                <div class="text-light mt">
                  <i class="iconfont icon-dtu" style="font-size: 100px;"></i>
                </div>
                <div>
                  <div :class="!ap.dtuid && 'mt'">
                    <span>终端型号：</span>
                    <span class="ml-xs">{{ ap.dtu_model || '其他' }}</span>
                  </div>
                  <div>
                    <span>MAC地址：</span>
                    <span class="ml-xs">{{ ap.mac || '' }}</span>
                  </div>
                  <div v-if="ap.dtuid" class="flex align-items-end">
                    <span style="line-height: 1">信号强度：</span>
                    <ap-dtu-singal :strength="ap.siginal_strength" class="ml-xs" style="zoom: .5;"></ap-dtu-singal>
                    <span class="ml-xs" style="line-height: 1;font-size: 14px">{{ ap.siginal_strength }}</span>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="bg-light radius5 flex column" style="height: 235px">
              <div class="hd front-line mt ml">物联卡</div>
              <div class="bd flex align-items-center column pb-md">
                <div class="text-light mt">
                  <i class="iconfont icon-Ap" style="font-size: 100px;"></i>
                </div>
                <div>
                  <div class="mt">
                    <span>ICCID：</span>
                    <span class="ml-xs">{{ ap.iccid || '无' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-card>
      <el-card shadow="never" class="mt-md flow">
        <div class="hd front-line mt">流量监控</div>
        <el-row v-if="ap.ap_type != 'nosim'" :gutter="20">
          <el-col v-if="flowList.length" :span="8" v-loading="flowLoading">
            <ApFlowProgress :flowList="flowList"/>
              <!-- <div v-for="(item,index) in flowList" :key="index">
                <div class style="padding: 15px;">
                  <div class="package-title mb">{{ item.title }}</div>
                  <div class="flex justify-content-space-between text-muted mb-xs">
                    <div>
                      已用
                      <span :class="item.used_flow < item.total_flow ? 'text-warning' : 'text-danger'">{{ item.used_flow.toFixed(2) + 'M' }}</span>
                    </div>
                    <div>{{ '剩余' + (item.total_flow - item.used_flow).toFixed(2) + 'M/共' + item.total_flow.toFixed(2) + 'M' }}</div>
                  </div>
                  <el-progress
                    :show-text="false"
                    :percentage="item.used_flow / item.total_flow * 100 > 100 ? 100 : item.used_flow / item.total_flow * 100"
                    :stroke-width="10"
                    :status="item.used_flow >= item.total_flow ? 'exception' : 'success'"
                    class="data-progress"
                  ></el-progress>
                </div>
              </div> -->
          </el-col>
          <el-col v-if="list" :span="16" v-loading="curveLoading">
            <ApDetailCurve :simid="ap.simid" :list="list"></ApDetailCurve>
          </el-col>
        </el-row>
        <div v-else class="flex-center mt-hg" style="width: 100%;height: 200px">
          <img src="../../assets/no-data.png" alt class="no-data" />
        </div>
      </el-card>
    </el-dialog>
</template>

<script>
import {
  apGetApi,
  apGetFlowApi,
  apDeleteApi,
  apGetFlowCurveApi
} from "@/api/ap/apApi";
import { apCartPostApi } from "@/api/ap/apRechargeApi";
import store from "@/store/store";
import router from "@/router/router";
export default {
  components: {
    ApDetailCurve: () => import("@/views/ap/components/ApDetailCurve"),
    ApDtuSingal: () => import("@/views/ap/components/ApDtuSingal"),
    ApFlowProgress: () => import("@/views/ap/components/ApFlowProgress"),
  },
  props: {},
  data() {
    return {
      show: false,
      simid: 0,
      apLoading: false,
      flowLoading: false,
      curveLoading: false,
      ap: {},
      flowList: [],
      list: {}
    };
  },
  created() {},

  // watch: {
  //   list(val) {
  //     console.log("val: ", val);
  //   },
  //   flowList(val) {
  //     console.log("val: fl", val);
  //   },
  // },

  methods: {
    fetchApDetail() {
      this.apLoading = true;
      apGetApi({ simid: this.simid }).then(res => {
        this.apLoading = false;
        if (!res.errno) {
          this.ap = Object.assign({}, res.data);
          if (this.ap.ap_type != "nosim") {
            this.fetchFlow(this.simid);
            this.fetchData();
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },

    fetchFlow() {
      this.flowLoading = true;
      apGetFlowApi({ simid: this.simid }).then(res => {
        this.flowLoading = false;
        if (!res.errno) {
          this.flowList = res.data.list;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    fetchData() {
      this.curveLoading = true;
      apGetFlowCurveApi({ simid: this.simid }).then(res => {
        this.curveLoading = false;
        if (!res.errno) {
          this.list = res.data.list[0];
        } else {
          this.$message.error(res.message);
        }
      });
    },

    open(simid) {
      this.show = true;
      this.simid = simid;
      this.fetchApDetail();
      store.commit("topay", false);
    },

    closeDialog() {
      this.show = false;
    },

    recharge() {
      const tempData = {
        simid: this.simid,
        num: 1,
        productid: this.ap.ap_productid
      };
      apCartPostApi({ data: [tempData] }).then(res => {
        if (res.errno === 0) {
          this.closeDialog();
          store.commit("topay", true);
          router.push("/ap/recharge/cart");
        } else {
          this.$message.error(res.message);
        }
      });
    },

    deleteAp() {
      this.$confirm(
        `将接入点 <span class="font-md text-success">${
          this.ap.simid
        }</span> 移至回收站，同时将设备 <span class="font-md text-success">${
          this.ap.equip_name
        }</span>  一并从设备监控列表删除，是否继续？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          type: "warning"
        }
      )
        .then(() => {
          apDeleteApi({ simid: this.ap.simid }).then(res => {
            if (res.errno === 0) {
              this.$message.success(
                "接入点 " + this.ap.simid + " 注销成功，可前往回收站赎回！"
              );
              store.commit("topay", true);
              this.closeDialog();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },

    equipDetail(equipid) {
      this.$detail({ type: "equip", id: equipid });
    }
  }
};
</script>

<style lang="scss">
.ap-detail.el-dialog {
  max-width: 1500px;
  height: 800px;
  .tip-area {
    position: relative;
    z-index: 999;
    .triangle {
      display: none;
      position: absolute;
      width: 0;
      height: 0;
      top: -15px;
      right: 0px;
      border-left: 15px solid transparent;
      border-right: 15px solid transparent;
      border-top: 10px solid #333;
    }
    .tooltip {
      position: absolute;
      padding-left: 8px;
      font-size: 12px;
      top: -50px;
      left: -86px;
      width: 210px;
      height: 40px;
      line-height: 40px;
      color: white;
      border-radius: 8px;
      background-color: #333;
      display: none;
    }
    &:hover {
      cursor: pointer;
      .triangle,
      .tooltip {
        display: block;
      }
    }
  }
}

.el-progress.data-progress {
  .el-progress-bar__outer {
    background-color: #DCDFE6;
    border-radius: 5px;
  }

  .el-progress-bar__inner {
    border-radius: 5px;
  }
}

.el-dialog__wrapper {
  .ap-detail.el-dialog {
    .el-dialog__header {
      padding: 0px;
      padding-left: 20px;
      height: 60px;
      .el-button--mini {
        height: 28px;
      }
      .remind {
        background-color: #fdeceb;
        color: rgba(230, 67, 64, 1);
        font-size: 14px;
        padding: 5px 15px;
        border-radius: 5px;
      }
    }

    .el-dialog__body {
      padding: 20px;
      background-color: #eef0f5;
    }

    .el-dialog__close.el-icon.el-icon-close {
      font-size: 24px;
    }
  }
}

.el-card.ap-desc {
  height: 300px;
  .el-card__body {
    margin-top: 10px;
  }
}

.el-card.flow {
  height: 385px;
}
</style>
